import type { TenantConfig } from '@/types/TenantConfig'

export const sandbox: TenantConfig = {
  ticketureTheme: true,
  teaserImageSize: {
    width: 320,
    height: 240,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    checkoutRoute: {
      stripeWallets: true,
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/sandbox/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      redeemMembershipRoute: {
        noMembershipsMessage:
          'There are no available memberships at this time. Please contact membership support at <u>memberships@ticketure.com</u> or <u>(406) 555-0120</u>.',
      },
    },
  },
}
